// English strings for BirthChartView, mounted under `birthChart.view` in
// i18n/locales/en/translation.js. Report copy itself comes from the server;
// these are only the labels around it.
const view = {
    yourChart: 'Your chart',
    pageTitle: 'Birth chart',
    close: 'Close',
    back: 'Go back',
    tabs: {
        label: 'Chart sections',
        bigThree: 'Big Three',
        chart: 'Birth Chart'
    },
    bigThree: {
        title: 'Meet your Big Three',
        hint: 'Tap each to go deeper',
        traits: 'Personality traits',
        lockedSign: 'Add birth time',
        lockedLabel: '{{planet}} is locked. Add your birth time and place to unlock it.',
        sun: 'Sun',
        moon: 'Moon',
        rising: 'Rising',
        labels: {
            sun: 'Your core',
            moon: 'Emotions',
            rising: 'Persona'
        }
    },
    chart: {
        wheelLabel: 'Your birth chart wheel',
        glance: 'Your chart at a glance',
        lifeThemes: 'Your life themes',
        planets: 'Your planets',
        houseLabel: '{{ordinal}} House'
    },
    ctas: {
        title: 'What you can do with your chart',
        tarot: 'Pull your cards',
        horoscope: 'Read today’s sky'
    },
    planetNames: {
        sun: 'Sun',
        moon: 'Moon',
        mercury: 'Mercury',
        venus: 'Venus',
        mars: 'Mars',
        jupiter: 'Jupiter',
        saturn: 'Saturn',
        uranus: 'Uranus',
        neptune: 'Neptune',
        pluto: 'Pluto',
        northNode: 'North Node'
    }
};

export default view;
